import { AbandonWriteErrorName } from './constants';

export default class AbandonWriteError extends Error {
  constructor(source: string) {
    super(`Event Limit reached. Abandoning write to: ${source}`);
    this.name = AbandonWriteErrorName;
  }
}
